import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// 請求攔截器 - 添加認證 token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 響應攔截器 - 處理認證錯誤
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 清除本地存儲的認證信息
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // 重定向到登入頁面
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const legacyEvaluationApi = {
  // 獲取舊評估記錄
  getLegacyEvaluations: () => api.get('/legacy-evaluations/').then(res => res.data),
  
  // 獲取舊評估記錄統計
  getLegacyEvaluationStats: () => api.get('/legacy-evaluation-stats/').then(res => res.data),
};
